import React, { FunctionComponent } from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Button } from '..';
import { useAppState } from '../../hooks';

export interface AddNewButtonsProps {
  editorVersion: string;
  isEditing: boolean;
  isEditorVersion2: boolean;
  addNewVar: (...args: any[]) => void;
}

const AddNewButtons: FunctionComponent<AddNewButtonsProps> = ({
  editorVersion, isEditing, addNewVar, isEditorVersion2,
}: AddNewButtonsProps) => {
  const { isCcsV2 } = useAppState();

  const newStatic = () => {
    const newContext = {
      name: isEditorVersion2 ? 'New attribute' : 'New static attribute',
      type: 'static',
      payload: '',
    };

    addNewVar(newContext);
  };

  const newFaas = () => {
    if (isCcsV2) {
      const newContext = {
        varName: 'New function',
        type: 'faas',
        payload: {},
      };

      addNewVar(newContext);
    } else {
      const newContext = {
        name: 'New function',
        type: 'faas',
        payload: {},
      };

      addNewVar(newContext);
    }
  };

  switch (editorVersion) {
    case 'v1':
      return (
        <Flex flex={1} mr={2}>
          <Box mr={2}>
            <Button
              variant="primary"
              onClick={newStatic}
              disabled={isEditing}
              data-testid="add-static-button"
            >
              Add Static
            </Button>
          </Box>
          <Box mr={2}>
            <Button
              variant="primary"
              onClick={newFaas}
              disabled={isEditing}
              data-testid="add-function-button"
            >
              Add Function
            </Button>
          </Box>
        </Flex>
      );
    case 'v2':
      return (
        <Flex flex={1} mr={2}>
          <Button
            variant="primary"
            onClick={newStatic}
            disabled={isEditing}
            data-testid="add-new-button"
          >
            Add New
          </Button>
        </Flex>
      );
    default:
      return null;
  }
};

export default AddNewButtons;
